import classnames from 'classnames';
import React, { JSX } from 'react';

import { AttentionMessage, AttentionMessageTypes } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';
import { Link } from '@eika/link';

type Link = {
    anchor: string;
    text: string;
};

export interface HeaderAttentionMessageProps {
    id?: string;
    message: string;
    moreText?: string;
    type?: AttentionMessageTypes;
    isNative?: boolean;
    link?: Link;
}

const HeaderAttentionMessage = ({
    id,
    message,
    link,
    moreText = '',
    type = 'error',
    isNative = false,
}: HeaderAttentionMessageProps): JSX.Element => {
    return (
        <section role="alert" className={classnames('attention-message-container', { native: isNative })}>
            <AttentionMessage
                id={id}
                icon={IconTypes.UTROPSTEGN_24}
                type={type}
                text={message}
                moreText={moreText}
                clickableItem={link && <Link href={link.anchor}>{link.text}</Link>}
                inlineClickableItem
            />
        </section>
    );
};

export default HeaderAttentionMessage;
